import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav nav-tabs" }
const _hoisted_2 = ["onClick"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsComponent',
  props: {
    selectedTab: {
        type: Number,
        required: true,
    },
    onTabChange: {
        type: Function as PropType<(tabIdx: number) => void>,
        required: true,
    },
    tabs: {
        type: Array<{ VALUE: number, LABEL: string }>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (organization) => {
      return (_openBlock(), _createElementBlock("li", {
        key: organization.VALUE,
        onClick: ($event: any) => (__props.onTabChange(organization.VALUE)),
        class: "nav-item"
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-black", { 'active': props.selectedTab === organization.VALUE }]),
          href: "#"
        }, _toDisplayString(organization.LABEL), 3)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})